module.exports = __webpack_public_path__ + "static/media/cloud2.2b67de32.png";